import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {RoleService} from "../../services/role.service";
import {OrdersBadgeService} from "../../home/services/orders-badge.service";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-orders-nav',
  templateUrl: './orders-nav.component.html',
  styleUrls: ['./orders-nav.component.css']
})
export class OrdersNavComponent implements OnInit, OnDestroy {

  @Input() activeMenuItem = '';
  public queuedForConversionCount : number|null = null;
  public queuedForExtensionCount : number|null = null;
  public exportableOrdersCount : number|null = null;
  public referralsPendingBonusCount : number|null = null;
  private sub1: Subscription;
  private sub2: Subscription;
  private sub3: Subscription;
  private sub4: Subscription;


  constructor(
    private roleService: RoleService,
    public ordersBadgeService: OrdersBadgeService,
  ) { }

  ngOnInit(): void {
    this.sub1 = this.ordersBadgeService.numExportableOrdersChanged$.subscribe(i => { this.exportableOrdersCount = i; });
    this.sub2 = this.ordersBadgeService.numQueuedForExtensionChanged$.subscribe(i => { this.queuedForExtensionCount = i; });
    this.sub3 = this.ordersBadgeService.numQueuedForConversionChanged$.subscribe(i => { this.queuedForConversionCount = i; });
    this.sub4 = this.ordersBadgeService.numReferralsPendingBonusChanged$.subscribe(i => { this.referralsPendingBonusCount = i; });

    this.queuedForConversionCount = this.ordersBadgeService.numQueuedForConversion;
    this.queuedForExtensionCount = this.ordersBadgeService.numQueuedForExtension;
    this.exportableOrdersCount= this.ordersBadgeService.numExportableOrders;
    this.referralsPendingBonusCount = this.ordersBadgeService.numReferralsPendingBonus;

    this.ordersBadgeService.getValues();
  }

  ngOnDestroy() {
    this.sub1.unsubscribe();
    this.sub2.unsubscribe();
    this.sub3.unsubscribe();
    this.sub4.unsubscribe();
  }

  currentUserIsPartner(): boolean {
    return this.roleService.hasRoles(['partner', 'partner_support']);
  }

  currentUserIsAdminOrComplianceOrFinanceManagerOrManager(): boolean {
    return this.roleService.hasRoles(['admin', 'compliance', 'finance_manager', 'manager']);
  }

}
